import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon';
import { Icons } from '~/components/Icon/constants';

import { canMakePhoneCalls } from '~/utils/browser/canMakePhoneCalls';
import styles from '../styles';

export type TPhoneNumberProps = {
  phoneNumber: string;
};

const ContactSheetPhoneNumber = ({ phoneNumber }: TPhoneNumberProps): ReactElement => {
  const { t } = useTranslation();
  const canMakeCalls = canMakePhoneCalls();
  let internationNumber = phoneNumber;
  if (!phoneNumber.startsWith('+')) {
    internationNumber = `+${phoneNumber}`;
  }
  const phoneContent = (
    <div css={styles.phoneNumberContainer}>
      <Icon iconColor="black" name={Icons.Call} />
      <div css={styles.phoneNumberText}>
        <span>{t('entity.entityLabel.station.callUs')}:</span>
        <span>{phoneNumber}</span>
      </div>
    </div>
  );
  return canMakeCalls ? <a href={`tel:${internationNumber}`}>{phoneContent}</a> : phoneContent;
};

export default ContactSheetPhoneNumber;
